import React from 'react';
import { Button, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import { FaFileAlt, FaGlobe } from 'react-icons/fa';

const AdditionalSettings = ({ 
    regeneratingDoc,
    regeneratingAllDoc,
    onRegenerateDocumentation,
    onRegenerateAllDocumentation
}) => {
    return (
        <Card sx={{ mt: 3 }}>
            <CardContent>
                <Typography variant="h6" component="h3" gutterBottom>
                    Додаткові налаштування
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        startIcon={regeneratingDoc ? <CircularProgress size={20} /> : <FaFileAlt />}
                        onClick={onRegenerateDocumentation}
                        disabled={regeneratingDoc || regeneratingAllDoc}
                    >
                        {regeneratingDoc ? 'Регенерація...' : 'Перестворити документацію'}
                    </Button> */}
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={regeneratingAllDoc ? <CircularProgress size={20} /> : <FaGlobe />}
                        onClick={onRegenerateAllDocumentation}
                        disabled={regeneratingDoc || regeneratingAllDoc}
                    >
                        {regeneratingAllDoc ? 'Регенерація всіх мов...' : 'Перестворити документацію (всі мови)'}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default AdditionalSettings;